import Link from "next/link";
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";
import User from "../Offcanvas/User";
import NotificationBell from "../Offcanvas/NotificationBell";
import LanguageMenu from "../Offcanvas/LanguageMenu";
import { useAppContext } from "@/context/Context";
import { useProfile } from "@/context/ProfileContext";

import { ROUTE } from "@/route/app_routes.js";

const initials = (first, last) =>
  (`${first || ""} ${last || ""}`)
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase() || "?";

const HeaderRight = ({ btnClass, userType }) => {

  const { mobile, setMobile, search, setSearch } = useAppContext();
  const router = useRouter();
  const { t } = useTranslation();
  // Shared profile cache (context/ProfileContext.js) instead of this component's own
  // getCurrentUser() fetch -- so a profile picture upload in Settings updates this navbar
  // avatar immediately, without a page refresh, the moment refreshProfile() resolves.
  const { profile: user, loading: profileLoading, loggedIn: contextLoggedIn } = useProfile();

  // The account-access divider (a ::after line) only makes sense next to the dashboard/admin
  // sidebar shell it was designed for -- on every public page it's just clutter next to the
  // notification bell's own spacing.
  const isDashboardShell = router.pathname.startsWith("/dashboard") || router.pathname.startsWith("/admin");

  const authChecked = !profileLoading;
  const loggedIn = authChecked && contextLoggedIn && !!user;

  return (
    <div className="header-right">

      <ul className="quick-access">
        <li className="access-icon rbt-mini-cart d-block d-lg-none">
          <Link
            className={`search-trigger-active rbt-round-btn ${ search ? "" : "open" }`}
            href="#"
            onClick={() => setSearch(!search)}
            aria-label={t("nav.search", "Search")}
          >
            <i className="feather-search"></i>
          </Link>
        </li>

        {/* Logged-out visitors get a small floating language widget instead (see
            HeaderContainer.js) -- this navbar spot is reserved for signed-in users, who already
            have Settings' Appearance tab as a second, more deliberate place to change it. */}
        {loggedIn && <LanguageMenu variant="icon" />}

        {loggedIn && <NotificationBell user={user} />}

        {loggedIn && (
          <li className={`account-access rbt-user-wrapper right-align-dropdown d-none d-xl-block ${isDashboardShell ? "" : "no-divider"}`}>
            <Link href="#" aria-label={t("nav.myAccount", "My Account")}>
              <span className="rbt-navbar-avatar" aria-hidden="true">{initials(user.FIRSTNAME, user.LASTNAME)}</span>
            </Link>
            <User user={user} />
          </li>
        )}
      </ul>


      {authChecked && !loggedIn && (
        <div className="rbt-btn-wrapper rbt-auth-links d-none d-xl-flex">
          <Link className="rbt-nav-login-link" href={ROUTE.login}>{t("nav.logIn", "Log In")}</Link>
          <Link className="rbt-btn rbt-nav-join-btn btn-sm hover-transform-none" href={ROUTE.register}>
            <span data-text={t("nav.joinForFree", "Join for Free")}>{t("nav.joinForFree", "Join for Free")}</span>
          </Link>
        </div>
      )}

      <div className="mobile-menu-bar d-block d-xl-none">
        <div className="hamberger">
          <button
            type="button"
            className="hamberger-button rbt-round-btn"
            onClick={() => setMobile(!mobile)}
            aria-label={mobile ? t("nav.openMenu", "Open menu") : t("nav.close", "Close menu")}
          >
            {loggedIn ? (
              <span className="rbt-navbar-avatar" aria-hidden="true">{initials(user.FIRSTNAME, user.LASTNAME)}</span>
            ) : (
              <i className="feather-menu"></i>
            )}
          </button>
        </div>
      </div>


    </div>
  );
};

export default HeaderRight;
